module.exports = __webpack_public_path__ + "img/bg_cupra.8c3fa3b9.jpg";